import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { get } from "./getPropertyByPath";
var AnaliticsObject = /*#__PURE__*/_createClass(function AnaliticsObject() {
  _classCallCheck(this, AnaliticsObject);
  _defineProperty(this, "objectParams", {});
  _defineProperty(this, "objectParamName", '');
  _defineProperty(this, "params", {});
  _defineProperty(this, "title", '');
  _defineProperty(this, "titleArray", []);
});
export var getAnaliticsParamFromArray = function getAnaliticsParamFromArray(arr, name) {
  if (arr) {
    return arr.filter(function (item) {
      return item.name == name;
    });
  }
};
export function handleAnalitics(obj) {
  var el = getAnaliticsParamFromArray(obj.objectParams, obj.objectParamName);
  tealiumClickFunc(tealiumMergeClickData(el ? el[0] : {}, obj.params), obj.title, obj.titleArray);
}
export function tealiumGenerateClickData(jsonData, text) {
  return _objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), jsonData), {}, {
    eventLab: text ? text : jsonData.eventLab
  });
}
export function getLastPartInURL(url) {
  var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\/';
  return url ? url.split(splitter).pop() ? url.split(splitter).pop() : url : '';
}
export function getLinkDomain(url) {
  return url ? url.replace(/(https:\/\/www\.|http:\/\/www\.|www\.|https:\/\/|http:\/\/)/, '') : '';
}
export function replaceInString(replaceId, replaceString, replaceText) {
  return replaceString.replace(replaceId, replaceText);
}
export function tealiumClickCustomFunc(jsonData) {
  var tealiumData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new TealiumData();
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    var utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;
    var utegResultObject = _objectSpread(_objectSpread({}, tealiumData), resObj);
    console.log(utegResultObject);
    if (utag) utag.link(utegResultObject);
  }
}
export function tealiumClickFunc(jsonData, text, textArray) {
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    var utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;

    var utegResultObject = _objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), resObj), {}, {
      eventLab: tealiumFlatDataSetParams(resObj.eventLab, text, textArray)
    });
    var finalObj = {
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab
    };
    if (Object.keys(utegResultObject).includes('email')) {
      finalObj['email'] = utegResultObject.email;
    }
    console.log(finalObj);
    if (utag) {
      utag.link(finalObj);
    }
    //}
  }
}
export function tealiumClickFuncExtended(jsonData, text) {
  var additinal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    var utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;
    var utegResultObject = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), resObj), additinal), {}, {
      eventLab: tealiumFlatDataSetParams(resObj.eventLab, text)
    });
    console.log({
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab,
      whats_on_event_name: utegResultObject.whats_on_event_name,
      event_venue: utegResultObject.event_venue,
      event_date: utegResultObject.event_date,
      event_type: utegResultObject.event_type
    });
    if (utag) utag.link({
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab,
      whats_on_event_name: utegResultObject.whats_on_event_name,
      event_venue: utegResultObject.event_venue,
      event_date: utegResultObject.event_date,
      event_type: utegResultObject.event_type
    });
    //}
  }
}
export function tealiumFlatData(data) {
  for (var key in data) {
    data[key] = get(data[key], 'jss.value', typeof data[key] == 'object' ? '' : data[key]);
  }
  return data;
}
function tealiumFlatDataSetParams(str, params, paramsArray) {
  var regEXP = new RegExp('\@[a-zA-Z]+\@|\#[a-zA-Z]+\#', "g");
  var counter = -1;
  if (!params) {
    return str;
  } else if (str && str.match(regEXP) && Array.isArray(params)) {
    str = str.replace(regEXP, function (e, i) {
      counter++;
      return params[counter];
    });
    return str;
  } else if (str && str.match(regEXP)) {
    return str.replace(regEXP, params);
  } else {
    return params;
  }
}
export function tealiumCheckRightTextClick(e, analyticsFunction) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var el = e.target;
  if (el && el.tagName === "A" && value) {
    tealiumClickFunc(analyticsFunction, [value, el.text]);
  } else if (el && el.tagName === "A") {
    tealiumClickFunc(analyticsFunction, el.text);
  }
}
export function tealiumMergeClickData(data, params) {
  var resObj = tealiumFlatData(data);
  return _objectSpread(_objectSpread({}, resObj), params);
}
export function tealiumFlatNewData(data) {
  for (var key in data) {
    data[key] = get(data[key], 'jss.value', typeof data[key] == 'object' ? '' : data[key]);
  }
  return data;
}
export function tealiumMergeClickNewData(data, params) {
  var resObj = tealiumFlatNewData(data);
  return _objectSpread(_objectSpread({}, resObj), params);
}
export var TealiumData = /*#__PURE__*/_createClass(function TealiumData() {
  _classCallCheck(this, TealiumData);
  _defineProperty(this, "eventName", '');
  _defineProperty(this, "eventCat", '');
  _defineProperty(this, "eventAct", '');
  _defineProperty(this, "eventLab", '');
});
export var TealiumData__LinkDescription = /*#__PURE__*/_createClass(function TealiumData__LinkDescription() {
  _classCallCheck(this, TealiumData__LinkDescription);
  _defineProperty(this, "title", '');
  _defineProperty(this, "context", '');
});